import type { IFilter } from "../models/Filter";
import type { JSONValue } from "../models/Json";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type BranchCreateDTO = {
  name: string;
  nameEng: string;
  type: string;
  logo?: string | null;
  profileBanners?: Array<{ url: string; isMain?: boolean }>;
  isDefault?: boolean;
  isBuyer?: boolean;
  isSupplier?: boolean;
  buyers?: string[];
  suppliers?: string[];
  isConfirmed?: boolean;
};
export const create = async (data: BranchCreateDTO) => {
  return httpRequest.post("/prt/branch", data);
};

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/prt/branch", { offset, filter });
};

export type BranchUpdateDTO = BranchCreateDTO;
export const update = async (id: string, data: BranchUpdateDTO) => {
  return httpRequest.put(`/prt/branch/${id}`, data);
};

export type BranchAddressDTO = {
  province: string;
  district: string;
  khoroo: string;
  khoroolol: string;
  khotkhonBair: string;
  khashaaDavkhar: string;
  khaalgaDugaar: string;
  branchAddress: string;
  locationLat: string | number;
  locationLng: string | number;
};
export const updateAddress = async (id: string, data: BranchAddressDTO) => {
  return httpRequest.put(`/prt/branch/${id}/address`, data);
};

export const roleSelect = async (data: Record<string, JSONValue>) => {
  return httpRequest.get("/prt/role/select", data);
};

export const get = async (id: string) => {
  return httpRequest.get(`/prt/branch/${id}`);
};
